import styles from './Fingerprint.module.css'

export interface FingerprintProps {
  value: string
  /** Characters kept at each end, e.g. `b8ef4a…3812`. */
  visibleChars?: number
}

/**
 * The monospace truncated-hash device used throughout Run Detail and the
 * receipt rendering — never the per-login session fingerprint (addendum §F
 * item 5 recommends dropping that one; this primitive is for run/content
 * fingerprints, which prove something).
 */
export function Fingerprint({ value, visibleChars = 6 }: FingerprintProps) {
  const truncated =
    value.length > visibleChars * 2
      ? `${value.slice(0, visibleChars)}…${value.slice(-visibleChars)}`
      : value

  return (
    <span className={styles['fingerprint']} title={value}>
      {truncated}
    </span>
  )
}
